import { Injectable }       from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }           from '../api/api.service';
import { CompanySettingsModel } from '../companies/models/company.settings';
import { ConfirmService }       from '../messages/confirm/confirm.service';
import { SessionService }       from '../sessions/session.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerPortalService {
  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private sessionService  : SessionService,
    private translateService: TranslateService
  ) {}

  activate () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
        name: this.translateService.instant('CUSTOMER_SPACE.CUSTOMER_PORTAL.TITLE')
      }))
      .then(() => this.apiService.patch('/company_settings', {
          has_customer_portal: true
        }, 'company_setting'))
      .then(() => this.sessionService.refresh());
  }

  deactivate () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', {
        name: this.translateService.instant('CUSTOMER_SPACE.CUSTOMER_PORTAL.TITLE')
      }))
      .then(() => this.apiService.patch('/company_settings', {
          has_customer_portal: false
        }, 'company_setting'))
      .then(() => this.sessionService.refresh());
  }

  getSettings () : Promise<CompanySettingsModel> {
    return this.apiService.get('/company_settings');
  }
}
